function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 8a2 2 0 012-2h20a2 2 0 010 4H2a2 2 0 01-2-2zM0 16a2 2 0 012-2h20a2 2 0 010 4H2a2 2 0 01-2-2z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.297.022a2 2 0 011.68 2.275l-3 20a2 2 0 01-3.955-.594l3-20A2 2 0 019.297.024zM18.297.022a2 2 0 011.68 2.275l-3 20a2 2 0 01-3.955-.594l3-20a2 2 0 012.275-1.68z"
});

function SvgNumber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default SvgNumber;